import {defineMessages} from 'react-intl.macro';

export const messages = defineMessages({
  'CHECKPOINT_TYPE_NAME_NOT_UNIQUE': {
    defaultMessage: 'There is already a Checkpoint Type with this name',
    id: 'CHECKPOINT_TYPE_NAME_NOT_UNIQUE'
  },
  'checkpointType.new.error': {
    defaultMessage: 'Failed to create checkpoint type',
    id: 'checkpointType.new.error'
  },
  'checkpointType.new.pageTitle': {
    defaultMessage: 'Create Checkpoint Type',
    id: 'checkpointType.new.pageTitle'
  },
  'checkpointType.new.success': {
    defaultMessage: 'Created checkpoint type',
    id: 'checkpointType.new.success'
  }
});
